import { createFileRoute } from "@tanstack/react-router";

function DemoIBS2023Start() {
  return (
    <>
      <a href="/demo/ibs-2023-selections">Selections</a>
      <br />
      <a href="/demo/ibs-2023-walkthrough">Walkthrough</a>
    </>
  );
}

export const Route = createFileRoute("/demo/ibs-2023-start")({
  component: DemoIBS2023Start,
});
